import { useAccountStore, useRevenueEachMonth } from "../../store";
import { useEffect, useState } from "react";
import { useGetRevenueEachMonthApi } from "../../hooks";
import toast from "react-hot-toast";
import {
  Bar,
  ResponsiveContainer,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Line,
  ComposedChart,
} from "recharts";
import { formatToVND } from "../../helper";
import LoadingItem from "../common/LoadingItem";

const DashBoardChartTopRight = () => {
  // state
  const [revenueData, setRevenueData] = useState<any>();

  // store
  const { setAccountId, setYear, year } = useRevenueEachMonth();

  // info
  const { info } = useAccountStore();

  // year current
  const currentDate = new Date();
  const yearCurrent = currentDate.getFullYear();

  // api
  const { isLoading, revenueEachMonth } = useGetRevenueEachMonthApi();

  useEffect(() => {
    if (info?.role && info?.role === "ROLE_ADMIN") {
      setAccountId(undefined);
    } else if (info?.role && info?.role === "ROLE_INVERTOR") {
      setAccountId(info?.id);
    }

    if (!year) {
      setYear(yearCurrent);
    } else {
      setYear(year);
    }

    if (revenueEachMonth?.data && revenueEachMonth?.code === 200) {
      const result = Object.entries(revenueEachMonth?.data).map(
        ([month, value]) => ({ month, value })
      );

      setRevenueData(result);
    } else if (
      revenueEachMonth?.code === 400 ||
      revenueEachMonth?.code === 404
    ) {
      toast.error("Get revenue each month all system failure !!!");
    }
  }, [info?.role, yearCurrent, isLoading, year]);

  const formatLabel = (value: any) => {
    return formatToVND(value);
  };

  return (
    <div id="chart" className="w-[100%] flex-col overflow-y-auto h-[100%] flex">
      {isLoading ? (
        <LoadingItem isLoading={isLoading} title={"Loading"}></LoadingItem>
      ) : (
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={revenueData}>
            <CartesianGrid strokeDasharray="3 3" />

            <XAxis style={{ fontSize: 9 }} dataKey="month" />

            <YAxis
              tickFormatter={formatLabel}
              style={{ fontSize: 9 }}
              dataKey="value"
            />

            <Tooltip
              formatter={(value: any) => {
                return `${formatToVND(value)}`;
              }}
            />

            <Legend />

            <Bar
              className="max-md:hidden"
              dataKey="value"
              fill="#72d2fc"
              barSize={22}
            />

            <Line
              tooltipType="none"
              dataKey="value"
              stroke="#99daf6"
              className=""
              type="monotone"
              strokeWidth={2}
              legendType="none"
            />
          </ComposedChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default DashBoardChartTopRight;
